export const LABEL_CREATION_ERROR = "Error creating a label! Please contact dev support ASAP"
export const AUSPOST_SERVER_ERROR = "Error connecting to Australia post! please try again later"